import * as React from 'react';
import Sidebar from 'admin/sidebar';
import LeaseContent from './LeaseContent';
import './_lease.scss';

export default function LeaseAbstraction(): JSX.Element {
  return (
    <div style={{ display: 'flex' }}>
      <Sidebar variant='settings' activeLink='lease-templates' />
      <LeaseContent />
    </div>
  );
}
